import { createAsyncThunk } from '@reduxjs/toolkit';
import { jobsService } from '../services/jobs.service';
import { JobsListParams, JobsListResponse } from '../interface/jobs.interface';

/**
 * Thunk to fetch the public list of jobs
 */
export const fetchPublicJobs = createAsyncThunk<JobsListResponse, JobsListParams | undefined>(
  'jobs/fetchPublic',
  async (params, { rejectWithValue }) => {
    try {
      const response = await jobsService.getPublicJobs(params || {});
      return response;
    } catch (error: any) {
      const apiMessage: string | undefined = error?.response?.data?.message;
      return rejectWithValue(apiMessage || 'Failed to load jobs.');
    }
  }
);
